
import Cookies from "js-cookie";

export function cleanRET_APPandRET_DCCookie() {
    const cookieNames = ["LIVEFX_RET_DC", "LIVEFX_RET_APP"]; // Array of cookie names to delete

    // console.log("Before removal:");
    // cookieNames.forEach(name => {
    //     console.log(`${name}: ${Cookies.get(name)}`);
    // });

    cookieNames.forEach(name => {
        Cookies.remove(name);
    });

    // console.log("After removal:");
    // cookieNames.forEach(name => {
    //     console.log(`${name}: ${Cookies.get(name)}`);
    // });
}
